import { render } from "./Shoping.vue?vue&type=template&id=7246b1bc&scoped=true"
import script from "./Shoping.vue?vue&type=script&lang=js"
export * from "./Shoping.vue?vue&type=script&lang=js"

import "./Shoping.vue?vue&type=style&index=0&id=7246b1bc&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7246b1bc"]])

export default __exports__